import React from "react";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

import "./style.css";

const Spinner = props => {
  const { myClass, size, tip } = props;

  return (
    <div
      className={"bodySpinner " + myClass + " " + size}
      style={{ position: "fixed", zIndex: "999" }}
    >
      <Spin
        indicator={<FontAwesomeIcon icon={["far", "circle-notch"]} spin />}
        size={size}
        tip={
          <span>
            <br />
            {tip || (
              <>
                <FormattedMessage id="generic.loadingMessage2" />{" "}
                <div>
                  <FormattedMessage id="generic.loadingMessage3" />{" "}
                </div>
              </>
            )}
          </span>
        }
        style={{ fontSize: "25px" }}
      />
    </div>
  );
};

export default Spinner;
